import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import Header from "@/components/Header";
import { adminLogin } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(email, password);
      toast.success("Bienvenido");
      navigate("/admin/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Error de autenticación";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-eje/[0.04]">
      <Header variant="light" />
      <main className="flex-1 flex items-center justify-center py-16">
        <div className="w-full max-w-md px-6">
          <div className="text-center mb-10">
            <div className="w-14 h-14 mx-auto bg-eje text-white flex items-center justify-center rounded-sm mb-4">
              <ShieldCheck className="w-7 h-7" />
            </div>
            <div className="overline text-eje mb-1">Acceso restringido</div>
            <h1
              className="font-serif text-3xl text-eje"
              data-testid="admin-login-title"
            >
              Panel administrador
            </h1>
            <p className="text-sm text-slate-600 mt-2">
              Ingresa tus credenciales institucionales para revisar las
              inscripciones.
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            className="card-eje p-8 space-y-5"
            data-testid="admin-login-form"
          >
            <div>
              <label className="label-eje" htmlFor="email">
                Correo electrónico
              </label>
              <input
                id="email"
                type="email"
                required
                className="input-eje"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@eje.gob.mx"
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <label className="label-eje" htmlFor="password">
                Contraseña
              </label>
              <div className="relative">
                <input
                  id="password"
                  type="password"
                  required
                  className="input-eje pr-10"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="admin-password-input"
                />
                <Lock className="w-4 h-4 text-slate-400 absolute right-3 top-1/2 -translate-y-1/2" />
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full btn-primary-eje inline-flex items-center justify-center gap-2"
              data-testid="admin-login-button"
            >
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" /> Validando…
                </>
              ) : (
                "Ingresar"
              )}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
